const MenuAsistente = [
  {
    path: '/', icon: 'fa fa-th', title: 'Inicio'
  }
]
export default MenuAsistente;